import { useEffect, useState } from "react";
import {
  ArrowRight,
  ArrowUpRight,
  FileText,
} from "lucide-react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

const RecruitmentPage = () => {
  const [active, setActive] = useState("");
  const [recruitmentData, setrecruitmentData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // ============================
  // FORMAT EVENT TYPE
  // ============================
  const formatEventType = (eventType) => {
    return eventType
      .replace(/-/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  // ============================
  // FETCH recruitment DATA
  // ============================
  useEffect(() => {
    const fetchrecruitmentData = async () => {
      try {
        setLoading(true);
        setError("");

        const API_URL =
          window.location.hostname === "localhost" ||
          window.location.hostname === "127.0.0.1"
            ? "http://127.0.0.1:8000/api/recruitments"
            : "https://api.kunainital.ac.in/api/recruitments";

        const response = await fetch(API_URL);

        if (!response.ok) {
          throw new Error("Failed to fetch recruitment documents");
        }

        const result = await response.json();

        if (result.status && result.data) {
          setrecruitmentData(result.data);

          const tabs = Object.keys(result.data);

          if (tabs.length > 0) {
            setActive(tabs[0]);
          }
        } else {
          setrecruitmentData({});
          setError("No recruitment documents found.");
        }
      } catch (err) {
        console.error("recruitment API Error:", err);
        setError("Unable to load recruitment documents.");
      } finally {
        setLoading(false);
      }
    };

    fetchrecruitmentData();
  }, []);

  // ============================
  // CURRENT DATA
  // ============================
  const currentData = recruitmentData[active] || [];

  return (
    <div className="min-h-screen bg-[var(--paper)]">

      <Header />

      {/* ================= HERO ================= */}

      <section className="relative h-[300px] overflow-hidden text-lg font-gill">

        <img
          src="/images/campusKumaun.avif"
          alt="Kumaun University"
          className="absolute inset-0 w-full h-full object-cover"
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#d1fae5]/95 via-[#a7f3d0]/80 to-[#ecfdf5]/40" />

        <div className="relative z-10 max-w-7xl mx-auto h-full px-4 flex items-center">

          <div className="max-w-3xl">

            {/* Breadcrumb */}
            <div className="flex items-center gap-2 text-sm mb-2">
                 <span className="text-[#123B5D] text-lg">
                Home
              </span>
                 <span className="text-[#123B5D] text-lg">
                    /
                  </span>

              <span className="text-[#123B5D] text-lg">
              Recruitment
              </span>

              {/* {active && (
                <>
                  <span className="text-[#123B5D] text-lg font-semibold">
                    /
                  </span>

                  <span className="text-[#123B5D] text-lg font-semibold">
                    {formatEventType(active)}
                  </span>
                </>
              )} */}

            </div>

            <h6 className="text-3xl md:text-5xl font-bold leading-tight text-[#064E3B]">
           IMPORTANT NOTIFICATION REGARDING RECRUITMENT
            </h6>

          </div>

        </div>
      </section>

      {/* ================= CONTENT ================= */}

      <section className="relative overflow-hidden bg-[#f8fafc] py-16 md:py-20 text-lg font-gill">

        {/* Background Shapes */}

        <div
          className="
            absolute
            -top-32
            -left-32
            w-80
            h-80
            rounded-full
            bg-[#B5121B]/5
          "
        />

        <div
          className="
            absolute
            -bottom-40
            -right-32
            w-96
            h-96
            rounded-full
            bg-[#08245c]/5
          "
        />

        <div className="relative max-w-7xl mx-auto px-6">

          {/* ================= HEADER ================= */}

          <div className="text-center">

            <div
              className="
                inline-flex
                items-center
                gap-2
                px-4
                py-2
                rounded-full
                bg-[#fff1f1]
                border
                border-[#B5121B]/10
              "
            >

              <span
                className="
                  w-2
                  h-2
                  rounded-full
                  bg-[#B5121B]
                  animate-pulse
                "
              />

              <span
                className="
                  text-[11px]
                  md:text-xs
                  font-bold
                  uppercase
                  tracking-[0.18em]
                  text-[#B5121B]
                "
              >
                Recruitment
              </span>

            </div>

            {/* <h2
              className="
                mt-5
                text-3xl
                md:text-5xl
                font-bold
                text-[#08245c]
              "
            >
              recruitment
              <span className="text-[#B5121B] ml-2">
                Documents
              </span>
            </h2> */}

            {/* Divider */}

            <div
              className="
                mt-6
                flex
                items-center
                justify-center
                gap-2
              "
            >

              <span
                className="
                  w-16
                  h-[3px]
                  rounded-full
                  bg-[#B5121B]
                "
              />

              <span
                className="
                  w-3
                  h-3
                  rotate-45
                  border-2
                  border-[#08245c]
                "
              />

              <span
                className="
                  w-16
                  h-[3px]
                  rounded-full
                  bg-[#08245c]
                "
              />

            </div>

          </div>

          {/* ================= LOADING ================= */}

          {loading && (
            <div className="mt-12 text-center text-gray-500">
              Loading recruitment documents...
            </div>
          )}

          {/* ================= ERROR ================= */}

          {!loading && error && (
            <div className="mt-12 text-center text-red-500">
              {error}
            </div>
          )}

          {/* ================= TABS ================= */}

          {!loading && !error && Object.keys(recruitmentData).length > 0 && (
            <div className="mt-10 flex flex-wrap justify-center gap-3">

              {Object.keys(recruitmentData).map((section) => {

                const isActive = section === active;

                return (
                  <button
                    key={section}
                    type="button"
                    onClick={() => setActive(section)}
                    className={`
                      inline-flex
                      items-center
                      gap-2
                      px-5
                      py-3
                      rounded-xl
                      border
                      text-sm
                      font-semibold
                      transition-all
                      uppercase
                      duration-300
                      ${
                        isActive
                          ? "bg-[#B5121B] text-white border-[#B5121B] shadow-lg -translate-y-0.5"
                          : "bg-white text-[#24364b] border-gray-200 hover:border-[#B5121B]/40 hover:text-[#B5121B] hover:-translate-y-0.5"
                      }
                    `}
                  >
                    <FileText size={17} />

                    {formatEventType(section)}
                  </button>
                );
              })}

            </div>
          )}

          {/* ================= CARDS ================= */}

          {!loading && !error && currentData.length > 0 && (
            <div className="mt-4">

              {currentData.map((item) => (

               <div
                    key={item.id}
                    className="
                        group
                        relative
                        flex
                        items-center
                        gap-5
                        bg-white
                        rounded-2xl
                        border
                        border-gray-300
                        p-1
                        md:p-2
                        overflow-hidden
                        shadow-sm
                        hover:shadow-[0_15px_35px_rgba(8,36,92,0.10)]
                        hover:-translate-y-1
                        transition-all
                        duration-300
                        mt-4
                        max-w-3xl
                        mx-auto
                    "
                    >

                  {/* Hover Red Line */}

                  <div
                    className="
                      absolute
                      left-0
                      top-0
                      bottom-0
                      w-1
                      bg-[#B5121B]
                      scale-y-0
                      group-hover:scale-y-100
                      transition-transform
                      duration-300
                    "
                  />

                  {/* ICON */}

                  <div
                    className="
                      shrink-0
                      w-10
                      h-10
                      rounded-xl
                      bg-[#B5121B]/10
                      flex
                      items-center
                      justify-center
                    "
                  >
                    <FileText
                      size={20}
                      className="text-[#B5121B]"
                    />
                  </div>

                  {/* Separator */}

                  <div className="h-14 w-px bg-gray-200" />

                  {/* CONTENT */}

                  <div className="flex-1 min-w-0">

                    <h3
                      className="
                        text-[15px]
                        md:text-[17px]
                        font-semibold
                        leading-6
                        text-[#24364b]
                        group-hover:text-[#B5121B]
                        transition-colors
                      "
                    >
                      {item.heading}
                    </h3>

                    <p
                      className="
                        mt-2
                        text-sm
                        leading-6
                        text-gray-500
                      "
                    >
                      {item.publish_date}
                    </p>

                    <button
                      type="button"
                      onClick={() => {

                        if (item.external_link) {

                          window.open(
                            item.external_link,
                            "_blank",
                            "noopener,noreferrer"
                          );

                        } else if (item.pdf_path) {

                          window.open(
                            item.pdf_path,
                            "_blank",
                            "noopener,noreferrer"
                          );

                        }

                      }}
                      className="
                        mt-3
                        inline-flex
                        items-center
                        gap-1.5
                        text-xs
                        font-bold
                        text-[#08245c]
                        group-hover:text-[#B5121B]
                      "
                    >
                      View Details

                      <ArrowUpRight size={14} />

                    </button>

                  </div>

                  {/* RIGHT ARROW */}

                  <div
                    className="
                      hidden
                      sm:flex
                      shrink-0
                      w-10
                      h-10
                      rounded-full
                      bg-[#f8fafc]
                      items-center
                      justify-center
                      text-[#08245c]
                      group-hover:bg-[#fff1f1]
                      group-hover:text-[#B5121B]
                      transition-all
                    "
                  >
                    <ArrowRight size={17} />
                  </div>

                </div>

              ))}

            </div>
          )}

          {/* NO DATA */}

          {!loading &&
            !error &&
            Object.keys(recruitmentData).length > 0 &&
            currentData.length === 0 && (
              <div className="mt-12 text-center text-gray-500">
                No documents available.
              </div>
            )}

        </div>

      </section>

      <Footer />

    </div>
  );
};

export default RecruitmentPage;